import React from "react";
import { Route, Switch } from "react-router";
import RedocOauth2Callback from "../components/redoc-tryout/redocAuthPopup/redocOauth2Callback";
import { ROUTES } from "./content";
import Page404 from "../components/404/404";

const ContentRouter = () => {
  return (
    <Switch>
      <Route path="/oauth2/redoc-callback" component={RedocOauth2Callback} />
      {ROUTES.map((route) => (
        <Route
          key={route.key}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      ))}
      {/* No route matched (e.g. /foo/bar, or the dev-only /test/* pages in a production
          build): show the 404 page instead of an empty content area */}
      <Route component={Page404} />
    </Switch>
  );
};

export default ContentRouter;
